module.exports = __webpack_public_path__ + "img/american-express.505007e4.svg";